var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Chat = function Chat(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 15 14' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'chat'
      ),
      React.createElement(
        'g',
        { fill: 'currentColor', fillRule: 'evenodd' },
        React.createElement('path', { d: 'M0 0v11h4v3h1l4-3h6V0H0zm14 10H9l-4 3v-3H1V1h13v9z' }),
        React.createElement('path', { d: 'M4 3h7v1H4V3zM4 5h7v1H4V5zM4 7h7v1H4V7z' })
      )
    )
  );
};
/*eslint-enable */

export default Chat;
//# sourceMappingURL=Chat.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Chat.js